export const Voluntary = () => { 
    return (
            <div className='main voluntary'>

                <div className='aside'><div></div></div>
                <div className='content has-aside static'>
                    
                        <a href="https://flintt.me/"><div className='nav-logo'></div></a>

<h1>VOLUNTARY REFUND POLICY</h1>

<p>Version number: 1</p>

<p>Effective date: 17.07.25</p>


<p>This Policy does not affect any applicable legal cancellation (“cooling off”) rights.</p>


<h2>1. 1-Week Premium (£2)</h2>
<p>Due to the short duration and low cost of this plan, no refunds will be issued under any circumstances.</p>

<h2>2. 1-Month Premium (£6)</h2>
<p>Refunds are only issued for unused days remaining after a minimum of 7 days' notice has been provided.</p>

<h3>Refund Calculation:</h3>
<p>Total Refund = (number of unused days - 7) × £0.14</p>
<p>If the remaining unused days after applying the 7-day notice period are fewer than 0, no refund is issued.</p>

<h3>Example:</h3>
<p>User cancels after 13 days → 17 days remain on the subscription.</p>
<p>After applying the 7-day notice period, 10 refundable days remain.</p>
<p>Refund = 10 × £0.14 = £1.40</p>

<h2>3. 1-Year Premium (£60)</h2>
<p>Refunds are only issued for unused days remaining after a minimum of 30 days' notice has been provided.</p>

<h3>Refund Calculation:</h3>
<p>Total Refund = (number of unused days - 30) × £0.14</p>
<p>If the remaining unused days after applying the 30-day notice period are fewer than 0, no refund is issued.</p>

<h3>Example:</h3>
<p>User cancels after 300 days → 65 days remain.</p>
<p>After applying 30-day notice, 35 refundable days remain.</p>
<p>Refund = 35 × £0.14 = £4.90</p>







                </div> 
            </div>
    )
}